const Base = require("./base.mixin");

class Component {
};

Object.assign(Component.prototype, Base);

module.exports = Component;